import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { SetOrgFeatureFlagsRequest } from '@/definitions/featureFlags'
import { SetOrgFeatureFlags } from '@/services/FeatureFlagService'

interface SetOrgFeatureFlagsVariables {
  orgId: string
  data: SetOrgFeatureFlagsRequest
}

export const useSetOrgFeatureFlags = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ orgId, data }: SetOrgFeatureFlagsVariables) =>
      SetOrgFeatureFlags(orgId, data),
    // The tab reports a failure against the flags the operator was editing.
    meta: { suppressGlobalError: true },
    onSuccess: (_flags, { orgId }) => {
      queryClient.invalidateQueries({ queryKey: ['org-feature-flags', orgId] })
    },
  })
}
